import { render, staticRenderFns } from "./BriefItem.vue?vue&type=template&id=938a58a0&scoped=true&"
import script from "./BriefItem.vue?vue&type=script&lang=js&"
export * from "./BriefItem.vue?vue&type=script&lang=js&"
import style0 from "./BriefItem.vue?vue&type=style&index=0&id=938a58a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938a58a0",
  null
  
)

export default component.exports